import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  CommentParam,
  StaggeredReceive,
  updateBillingOrderParam,
} from "features/stock-ordering/core/stock-ordering.params";
import {
  staggeredReceiveRepository,
  staggeredReceiveResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum staggeredReceiveState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: staggeredReceiveState;
  message: string;
}

const initialState: InitialState = {
  status: staggeredReceiveState.initial,
  message: "",
};

export const staggeredReceive = createAsyncThunk(
  "staggeredReceive",
  async (param: StaggeredReceive, { rejectWithValue }) => {
    try {
      const response: staggeredReceiveResponse =
        await staggeredReceiveRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const staggeredReceiveSlice = createSlice({
  name: "staggeredReceive",
  initialState,
  reducers: {
    resetstaggeredReceive: (state) => {
      state.status = staggeredReceiveState.initial;
      state.message = "Reset request";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(staggeredReceive.pending, (state) => {
        state.status = staggeredReceiveState.inProgress;
      })
      .addCase(staggeredReceive.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = staggeredReceiveState.success;
          state.message = message;
        }
      })
      .addCase(staggeredReceive.rejected, (state, action) => {
        state.status = staggeredReceiveState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectstaggeredReceive = (state: RootState) =>
  state.staggeredReceive;

export default staggeredReceiveSlice.reducer;
